import { useContext, useMemo } from 'react'
import { AppShell } from '@shared/components/app-shell/app-shell'
import { LogoutLink } from '@/components/shared/logout-link/logout-link'
import { MAIN_MENU_LINKS } from '@/constants/menus'
import { Logo } from '@/components/shared/logo/logo'
import { Search } from '@/components/shared/search/search'
import { UserContext } from '@/providers/user-context'
import { routes } from '@/routing/routes'

function filterMenuLinksByRole(roles: string[]) {
  if (roles.includes('AllAccessUser')) return MAIN_MENU_LINKS
  if (roles.includes('WoolStoreUser')) {
    const allowedLinks = [routes.home.path, routes.woolStoreTools.path]
    return MAIN_MENU_LINKS.filter((link) => allowedLinks.includes(link.href))
  }
  // No roles: no menu
  return []
}
export function AppShellWrapper() {
  const { roles } = useContext(UserContext)

  const filteredMenuLinks = useMemo(() => filterMenuLinksByRole(roles ?? []), [roles])

  // Only show the search component if the user has the 'AllAccessUser' role
  const searchComponent = useMemo(() => {
    return (roles ?? []).includes('AllAccessUser') ? <Search /> : null
  }, [roles])

  return (
    // Return the app shell if roles are found
    <AppShell
      menuLinks={filteredMenuLinks}
      logoComponent={<Logo />}
      searchComponent={searchComponent}
      logoutComponent={<LogoutLink />}
    />
  )
}
